import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { buildLoginPath } from '@/auth/redirect'
import { useAuth } from '@/auth/useAuth'
import { FullPageLoader } from '@/components/ui/Spinner'

/**
 * Route guard for everything except /login. Sends anonymous visitors to the login
 * screen with the path they wanted preserved twice over: in `?next=` (survives a full
 * page load, e.g. the api client's hard redirect) and in router state (survives a
 * URL the user might otherwise see and be confused by).
 */
export function RequireAuth() {
  const { status } = useAuth()
  const location = useLocation()

  // AuthProvider normally absorbs this, but a guard that assumes otherwise is fragile.
  if (status === 'loading') {
    return <FullPageLoader label="Checking your session" />
  }

  if (status !== 'authenticated') {
    return <Navigate to={buildLoginPath(location)} replace state={{ from: location }} />
  }

  return <Outlet />
}
